
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
const requireComponent = require.context(
  '.', true, /\.vue$/
  // 找到components文件夹下以.vue命名的文件
);

export default {
  install(Vue) {
    requireComponent.keys().forEach(pathName => {
      const componetConfig = requireComponent(pathName);
      const fileName = `.${pathName.slice(pathName.lastIndexOf('/'))}`;
      const componetName = capitalizeFirstLetter(
        fileName.replace(/^\.\//, '').replace(/\.\w+$/, '')
      );
      Vue.component(componetName, componetConfig.default || componetConfig);
    });
  }
};
